import Highcharts, { Options, SeriesLineOptions } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ErrorBoundary } from 'components/molecules/error-boundary';
import { ErrorContent } from '../error';

const options: Options = {
  title: {
    text: undefined,
  },
  chart: {
    height: '80%',
  },
  xAxis: {
    gridLineColor: 'transparent',
    labels: {
      enabled: false,
    },
    lineColor: 'var(--coolest-gray-20)',
    lineWidth: 1,
    title: {
      text: 'Time',
    },
  },
  yAxis: {
    gridLineColor: 'transparent',
    labels: {
      enabled: false,
    },
    lineWidth: 1,
    lineColor: 'var(--coolest-gray-20)',
    title: {
      text: 'Work',
    },
  },

  legend: {
    layout: 'horizontal',
    align: 'left',
  },

  plotOptions: {
    series: {
      label: {
        connectorAllowed: false,
      },
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 300,
        },
        chartOptions: {
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom',
          },
        },
      },
    ],
  },
  tooltip: {
    enabled: false,
  },
};

const HighChartsWrapper = styled.div`
  .highcharts-tick {
    display: none;
  }
`;

export const DataContent: FC<{
  data: { series: Array<Partial<SeriesLineOptions>> };
  refetch(): void;
}> = ({ data, refetch }) => {
  return (
    <ErrorBoundary fallback={() => <ErrorContent onErrorRefresh={refetch} />}>
      <HighChartsWrapper>
        <HighchartsReact
          highcharts={Highcharts}
          options={{ ...options, ...data }}
        />
      </HighChartsWrapper>
    </ErrorBoundary>
  );
};
